/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration for row-based value constraints from another table
 * @export
 * @interface TableRowConstraintDto
 */
export interface TableRowConstraintDto {
    /**
     * Reference to the constraint table that defines allowed value mappings
     * @type {string}
     * @memberof TableRowConstraintDto
     */
    constraintTableReference?: string;
    /**
     * Column index in constraint table that matches the key (e.g., Rollen-ID)
     * @type {number}
     * @memberof TableRowConstraintDto
     */
    constraintTableKeyColumnIndex?: number;
    /**
     * Column index in constraint table with allowed values (e.g., Permission-ID)
     * @type {number}
     * @memberof TableRowConstraintDto
     */
    constraintTableValueColumnIndex?: number;
    /**
     * Column index in current table row to use as the lookup key
     * @type {number}
     * @memberof TableRowConstraintDto
     */
    thisTableKeyColumnIndex?: number;
}

/**
 * Check if a given object implements the TableRowConstraintDto interface.
 */
export function instanceOfTableRowConstraintDto(value: object): value is TableRowConstraintDto {
    return true;
}

export function TableRowConstraintDtoFromJSON(json: any): TableRowConstraintDto {
    return TableRowConstraintDtoFromJSONTyped(json, false);
}

export function TableRowConstraintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableRowConstraintDto {
    if (json == null) {
        return json;
    }
    return {
        
        'constraintTableReference': json['constraintTableReference'] == null ? undefined : json['constraintTableReference'],
        'constraintTableKeyColumnIndex': json['constraintTableKeyColumnIndex'] == null ? undefined : json['constraintTableKeyColumnIndex'],
        'constraintTableValueColumnIndex': json['constraintTableValueColumnIndex'] == null ? undefined : json['constraintTableValueColumnIndex'],
        'thisTableKeyColumnIndex': json['thisTableKeyColumnIndex'] == null ? undefined : json['thisTableKeyColumnIndex'],
    };
}

export function TableRowConstraintDtoToJSON(json: any): TableRowConstraintDto {
    return TableRowConstraintDtoToJSONTyped(json, false);
}

export function TableRowConstraintDtoToJSONTyped(value?: TableRowConstraintDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'constraintTableReference': value['constraintTableReference'],
        'constraintTableKeyColumnIndex': value['constraintTableKeyColumnIndex'],
        'constraintTableValueColumnIndex': value['constraintTableValueColumnIndex'],
        'thisTableKeyColumnIndex': value['thisTableKeyColumnIndex'],
    };
}

